import React, { useEffect, useState } from 'react';
import { Card, Form, Row, Col, Button, Spinner, Alert } from 'react-bootstrap';
import { toast } from 'react-toastify';
import axios from '../../../api/axios';

const BoosterPoint = ({ levels }) => {
    const accessToken = localStorage.getItem('authToken');
    const [inputData, setInputData] = useState({
        level: '',
        type: '',
        rewardType: '',
        interval: '',
        value: '',
    });
    const [isLoading, setIsLoading] = useState(false);
    const [filteredLevels, setFilteredLevels] = useState([]);
    const [isFormValid, setIsFormValid] = useState(false);

    useEffect(() => {
        setIsFormValid(
            inputData.level !== '' && 
            inputData.type !== '' && 
            inputData.rewardType !== '' && 
            inputData.interval !== '' && 
            inputData.value !== ''
        );
    }, [inputData]);

    const filterLevels = () => {
        const level = levels?.filter(item => item.sequenceNo !== 1);
        const filtered = level?.filter(item => item.sequenceNo !== 2);
        setFilteredLevels(filtered);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setInputData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);

        try {
            const headers = { Authorization: `Bearer ${accessToken}` };
            const data = {
                level: inputData.level,
                type: inputData.type,
                rewardType: inputData.rewardType,
                applyingConditions: {
                    interval: inputData.interval,
                    value: inputData.value,
                },
            };

            const response = await axios.post('level-reward', data, { headers });
            if (response?.data?.status === true) {
                toast.success(response?.data?.data?.message, {
                    position: 'top-right',
                    autoClose: 3000,
                    theme: 'colored',
                });
                setInputData({
                    level: '',
                    type: '',
                    rewardType: '',
                    interval: '',
                    value: '',
                });
            }
        } catch (error) {
            const errorMessage = error?.response?.data?.error?.message || 
                               error?.response?.data?.error || 
                               "Something went wrong";
            toast.error(errorMessage, {
                position: 'top-right',
                autoClose: 3000,
                theme: 'colored',
            });
        } finally {
            setIsLoading(false);
        }
    };

    useEffect(() => {
        filterLevels();
    }, [levels]);

    return (
        <Card className="border-0 shadow-sm">
            <Card.Header className="bg-white border-bottom-0 pb-0">
                <Row>
                    <Col className='p-1'>
                        <div className='d-flex'>
                            <h5 className="fw-bold">BOOSTER POINTER</h5>
                            <p className="text-muted mb-0 ms-1">(Configure point booster rewards for loyalty levels).</p>
                        </div>
                    </Col>
                    <hr />
                </Row>
            </Card.Header>
            <Form onSubmit={handleSubmit}>
                <Card.Body className="pt-0">
                    <Row className="gy-3">
                        <Col md={4}>
                            <Form.Group>
                                <Form.Label className="fw-semibold">
                                    Level <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Select
                                    name="level"
                                    value={inputData.level}
                                    onChange={handleChange}
                                    className="form-select"
                                >
                                    <option value="">Select level</option>
                                    {filteredLevels.map(level => (
                                        <option key={level._id} value={level._id}>
                                            {level.title}
                                        </option>
                                    ))}
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col md={4}>
                            <Form.Group>
                                <Form.Label className="fw-semibold">
                                    Reward Type <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Select
                                    name="type"
                                    value={inputData.type}
                                    onChange={handleChange}
                                    className="form-select"
                                >
                                    <option value="">Select type</option>
                                    <option value="COUPON">Coupon</option>
                                    <option value="REWARD">Reward</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col md={4}>
                            <Form.Group>
                                <Form.Label className="fw-semibold">
                                    Booster Type <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Select
                                    name="rewardType"
                                    value={inputData.rewardType}
                                    onChange={handleChange}
                                    className="form-select"
                                >
                                    <option value="">Select type</option>
                                    <option value="POINT_BOOSTER">Point Booster</option>
                                    <option value="GIFT">Gift</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>

                    <hr className="my-4" />

                    <h6 className="fw-bold mb-3">Applying Conditions</h6>

                    <Row className="gy-3">
                        <Col md={6}>
                            <Form.Group>
                                <Form.Label className="fw-semibold">
                                    Interval <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Select
                                    name="interval"
                                    value={inputData.interval}
                                    onChange={handleChange}
                                    className="form-select"
                                >
                                    <option value="">Select interval</option>
                                    <option value="WEEKLY">Weekly</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>

                        <Col md={6}>
                            <Form.Group>
                                <Form.Label className="fw-semibold">
                                    Day <span className="text-danger">*</span>
                                </Form.Label>
                                <Form.Select
                                    name="value"
                                    value={inputData.value}
                                    onChange={handleChange}
                                    className="form-select"
                                >
                                    <option value="">Select day</option>
                                    <option value="0">Sunday</option>
                                    <option value="1">Monday</option>
                                    <option value="2">Tuesday</option>
                                    <option value="3">Wednesday</option>
                                    <option value="4">Thursday</option>
                                    <option value="5">Friday</option>
                                    <option value="6">Saturday</option>
                                </Form.Select>
                            </Form.Group>
                        </Col>
                    </Row>
                </Card.Body>
                <Card.Footer className="bg-white border-top-0 pt-0 text-end">
                    <Button 
                        variant="primary" 
                        type="submit" 
                        disabled={!isFormValid || isLoading}
                        className="px-4 py-2"
                    >
                        {isLoading ? (
                            <>
                                <Spinner as="span" animation="border" size="sm" className="me-2" />
                                Saving...
                            </>
                        ) : 'Save Configuration'}
                    </Button>
                </Card.Footer>
            </Form>
        </Card>
    );
};

export default BoosterPoint;